// The page scroll lock shared by the overlays that lock <body> (ResponsiveModal, MobileFilterSheet,
// GlobalSearch).
// Each open overlay holds one lock and releases it when it closes AND when it unmounts while open
// (a back gesture, or the layout crossing 1024px). The page unlocks only when the last holder lets
// go, so one of two stacked overlays closing (or unmounting) never unlocks the page under the other,
// and no overlay can leave the page stuck unscrollable after everything has closed.
// GlobalSearch holds a lock the same way while the palette is open.

let holders = 0

/** Locks page scrolling; returns the release (calling it more than once is harmless). */
export function lockBodyScroll(): () => void {
  if (typeof document === 'undefined') return () => {}
  holders += 1
  document.body.style.overflow = 'hidden'
  let released = false
  return () => {
    if (released) return
    released = true
    holders = Math.max(0, holders - 1)
    if (holders === 0) document.body.style.overflow = ''
  }
}

/** How many overlays hold the lock right now (for tests). */
export function scrollLockHolders(): number {
  return holders
}
